module.exports = __webpack_public_path__ + "static/img/b6.fdc8a18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/b6.png
// module id = XH5d
// module chunks = 1